var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "subscription_",
    "data-name": "subscription ",
    transform: "translate(2619 -5635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    transform: "translate(-2619 5635)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 92,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "contract_2_",
    "data-name": "contract (2)",
    transform: "translate(-2612 5642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M360,75.126h14.825a2.7,2.7,0,0,0,2.7-2.7V34.7a2.7,2.7,0,0,0-2.7-2.7H360",
    transform: "translate(-299.354 -26.609)",
    fill: "#ffc24f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M360,154.308v5.051h14.825a2.7,2.7,0,0,0,2.7-2.7V133.3A74.15,74.15,0,0,1,360,154.308Zm0,0",
    transform: "translate(-299.354 -110.842)",
    fill: "#fab839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M130.7,0h29.649a2.7,2.7,0,0,1,2.7,2.7V51.212a2.7,2.7,0,0,1-2.7,2.7H130.7a2.7,2.7,0,0,1-2.7-2.7V2.7A2.7,2.7,0,0,1,130.7,0Zm0,0",
    transform: "translate(-106.437)",
    fill: "#4398d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M144.8,114.3h29.514a2.7,2.7,0,0,0,2.7-2.7V72.633C170.685,95.309,154.677,108.326,144.8,114.3Zm0,0",
    transform: "translate(-120.408 -60.397)",
    fill: "#3e8cc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M2.7,32A2.7,2.7,0,0,0,0,34.7V72.431a2.7,2.7,0,0,0,2.7,2.7H17.52V32Zm0,0",
    transform: "translate(0 -26.609)",
    fill: "#88b337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M53.442,251.227v-7.45a90.339,90.339,0,0,1-10.243,7.45Zm0,0",
    transform: "translate(-35.922 -202.71)",
    fill: "#80ab30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M186.7,232h10.781a2.7,2.7,0,0,1,0,5.391H186.7a2.7,2.7,0,1,1,0-5.391Zm0,0",
    transform: "translate(-153.003 -192.917)",
    fill: "#87ced9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M42.7,216a2.7,2.7,0,1,0,0,5.391h8.086V216Zm0,0",
    transform: "translate(-33.262 -179.613)",
    fill: "#a7d64f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M368.086,216H360v5.391h8.086a2.7,2.7,0,0,0,0-5.391Zm0,0",
    transform: "translate(-299.354 -179.613)",
    fill: "#ffe7ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M188.755,306.807a2.7,2.7,0,0,0-3.148,2.659,2.7,2.7,0,1,0-5.391,0,2.7,2.7,0,1,0-5.391,0V298.829a2.8,2.8,0,0,0-2.243-2.8,2.7,2.7,0,0,0-3.148,2.659v18.868l-5.618-3.369a2.376,2.376,0,0,0-2.291-.089l-.211.107a2.38,2.38,0,0,0-.317,4.063l8.438,6.027H191v-14.68a2.8,2.8,0,0,0-2.243-2.8Zm0,0",
    transform: "translate(-133.047 -246.125)",
    fill: "#fec9a3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662",
    transform: "translate(26.954 5.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M184,32h2.7v2.7H184Zm0,0",
    transform: "translate(-179.957 -32)",
    fill: "#126099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M216,32h10.781v2.7H216Zm0,0",
    transform: "translate(-206.566 -32)",
    fill: "#126099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M160,72h2.7v5.391H160Zm0,0",
    transform: "translate(-160 -65.262)",
    fill: "#126099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M192,72h2.7v5.391H192Zm0,0",
    transform: "translate(-186.609 -65.262)",
    fill: "#126099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M224,72h2.7v5.391H224Zm0,0",
    transform: "translate(-213.219 -65.262)",
    fill: "#126099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M256,72h2.7v5.391H256Zm0,0",
    transform: "translate(-239.828 -65.262)",
    fill: "#126099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M288,72h2.7v5.391H288Zm0,0",
    transform: "translate(-266.437 -65.262)",
    fill: "#126099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M224,128h9.434v2.7H224Zm0,0",
    transform: "translate(-213.219 -111.828)",
    fill: "#126099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M184,128h4.043v2.7H184Zm0,0",
    transform: "translate(-179.957 -111.828)",
    fill: "#126099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M184,160h16.172v2.7H184Zm0,0",
    transform: "translate(-179.957 -138.437)",
    fill: "#126099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M200,192h10.781v2.7H200Zm0,0",
    transform: "translate(-193.262 -165.046)",
    fill: "#126099"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M80,56h4.043v2.7H80Zm0,0",
    transform: "translate(-66.523 -46.566)",
    fill: "#70942d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M24,96h2.7v4.043H24Zm0,0",
    transform: "translate(-19.957 -79.828)",
    fill: "#70942d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M56,96h2.7v4.043H56Zm0,0",
    transform: "translate(-46.566 -79.828)",
    fill: "#70942d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M88,96h2.7v4.043H88Zm0,0",
    transform: "translate(-73.175 -79.828)",
    fill: "#70942d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M48,56h2.7v2.7H48Zm0,0",
    transform: "translate(-39.914 -46.566)",
    fill: "#70942d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M56,144h8.086v2.7H56Zm0,0",
    transform: "translate(-46.566 -119.742)",
    fill: "#70942d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M72,176h5.391v2.7H72Zm0,0",
    transform: "translate(-59.871 -146.351)",
    fill: "#70942d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M360,56h9.434v2.7H360Zm0,0",
    transform: "translate(-299.354 -46.566)",
    fill: "#ed9624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M424,96h2.7v4.043H424Zm0,0",
    transform: "translate(-352.573 -79.828)",
    fill: "#ed9624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M392,96h2.7v4.043H392Zm0,0",
    transform: "translate(-325.963 -79.828)",
    fill: "#ed9624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M360,96h2.7v4.043H360Zm0,0",
    transform: "translate(-299.354 -79.828)",
    fill: "#ed9624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M360,144h6.738v2.7H360Zm0,0",
    transform: "translate(-299.354 -119.742)",
    fill: "#ed9624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M360,176h4.043v2.7H360Zm0,0",
    transform: "translate(-299.354 -146.351)",
    fill: "#ed9624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M213.879,411.227h21.563V400.535c-6.654,5.51-15.655,8.693-21.993,10.377Zm0,0",
    transform: "translate(-177.491 -333.061)",
    fill: "#f7bb8f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.7936f308d5e77e76446d7e2dabc559a1.svg";
export { ForwardRef as ReactComponent };